var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.125C0 1.39893 1.41758 0 3.16667 0H11.0833V6.25C11.0833 7.11426 11.7909 7.8125 12.6667 7.8125H19V21.875C19 23.5986 17.5799 25 15.8333 25H3.16667C1.41758 25 0 23.5986 0 21.875V3.125ZM12.6667 6.25V0L19 6.25H12.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.688 18H3.936C5.232 18 6.264 17.456 6.264 16.24C6.264 15.448 5.808 15 5.208 14.84V14.808C5.688 14.624 5.984 14.048 5.984 13.52C5.984 12.376 5 12.04 3.768 12.04H1.688V18ZM3.12 14.408V13.136H3.712C4.312 13.136 4.592 13.312 4.592 13.736C4.592 14.144 4.32 14.408 3.712 14.408H3.12ZM3.12 16.904V15.456H3.832C4.528 15.456 4.872 15.656 4.872 16.144C4.872 16.656 4.52 16.904 3.832 16.904H3.12ZM9.6345 18.112C11.2185 18.112 12.0185 17.208 12.0185 15.2V12.04H10.6425V15.352C10.6425 16.48 10.2825 16.88 9.6345 16.88C8.9785 16.88 8.6425 16.48 8.6425 15.352V12.04H7.2185V15.2C7.2185 17.208 8.0425 18.112 9.6345 18.112ZM14.1575 18H15.5815V15.896L17.3815 12.04H15.8855L15.3895 13.368C15.2215 13.816 15.0615 14.232 14.8935 14.696H14.8615C14.6935 14.232 14.5415 13.816 14.3815 13.368L13.8855 12.04H12.3655L14.1575 15.896V18Z",
    fill: "#495376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.78c8760b10257925731fe271895d94ae.svg";
export { ForwardRef as ReactComponent };